<template>
    <div>
        <!-- 课程目录 -->
        <el-table
            v-if="type === 'baseCourse'"
            :data="tableDatas"
            style="width: 100%"
            :cell-style="{
                'font-size': '16px',
                color: '#333',
            }"
            :header-cell-style="{
                'background-color': '#d7d7d7',
                'font-weight': '700',
                color: '#333',
                'font-size': '14px',
            }"
        >
            <el-table-column
                label="批次号/班级编号"
                prop="batch"
                align="center"
                header-align="center"
                style="color: #409eff;"
            />
            <el-table-column
                label="班级名称"
                prop="albumTitle"
                align="center"
                header-align="center"
            />
            <el-table-column
                label="课程状态"
                prop="status"
                align="center"
                header-align="center"
            />
            <el-table-column
                label="开课机构"
                prop="rkMhmName"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="任课老师"
                prop="rkTeacherName"
                align="center"
                header-align="center"
            />
            <el-table-column
                label="学习人数"
                prop="stuTotalNum"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="平均分"
                prop="averageScore"
                align="center"
                header-align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.isShow?scope.row.averageScore:'点击"查看"' }}
              </template>
            </el-table-column>
            <el-table-column
                label="合格占比"
                prop="passRatio"
                align="center"
                header-align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.isShow?scope.row.passRatio+'%':'点击"查看"' }}
              </template>
            </el-table-column>
            <el-table-column
                label="良好占比"
                prop="middleRatio"
                align="center"
                header-align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.isShow?scope.row.middleRatio+'%':'点击"查看"' }}
              </template>
            </el-table-column>
            <el-table-column
                label="优秀占比"
                prop="topRatio"
                align="center"
                header-align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.isShow?scope.row.topRatio+'%':'点击"查看"' }}
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                header-align="center"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="handleCheck(scope.row)">查看</el-button>
              </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import {getRatioByBatchId} from '@/api/TeachingStatistics'
export default {
    props: ["type", "tableData"],
    data(){
      return {
        tableDatas: this.tableData
      }
    },
    methods: {
      /** 选择专业查看 */
      handleSelected(row){
        this.$emit('changes',row)
      },
      /** 查看占比 */
      async handleCheck(row){
        let newRow = JSON.parse(JSON.stringify(row));
        let {data} = await getRatioByBatchId({batch:newRow.batch});
        if(data.code===100000){
          newRow.passRatio = data.data.passRatio;
          newRow.middleRatio = data.data.middleRatio;
          newRow.topRatio = data.data.topRatio;
          newRow.averageScore = data.data.averageScore;
          newRow.isShow = true;
          let index = this.tableDatas.findIndex(v=>v.batch===newRow.batch);
          this.$set(this.tableDatas,index,newRow)
        }
      }
    },
    watch:{
      tableData:function(val){
        this.tableDatas = val;
      }
    }
};
</script>

